import Entity from './Entity';
import SpriteAnimation from '../common/SpriteAnimation';
import config from '../common/config';

function Enemy(img, x = 0, y = 0, dx = 0, dy = 0, width, height, animationSpeed = 1) {
    Entity.apply(this, arguments);
    this.width = width;
    this.height = height;
    this.animationSpeed = animationSpeed;
    this.img = (img.width > this.width || img.height > this.height)? new SpriteAnimation(this): img;
}

function getSprite() {
    const spriteObj = {
        dx: this.x,
        dy: this.y,
        image: this.image,
    };
    if("getFrame" in this.img) {
        return {...spriteObj, ...this.img.getFrame(this.animationSpeed * config.speed)};
    }
    return spriteObj;
}

function update() {
    this.move();
    if("nextFrame" in this.img) {
        this.img.nextFrame();
    }
}

Enemy.prototype = Object.create(Entity.prototype);
Enemy.prototype.constructor = Enemy;
Enemy.prototype.getSprite = getSprite;
Enemy.prototype.update = update;

export default Enemy;
